import { useMutation } from 'react-query'

import { xService } from 'src/services/x.service'
import { EXBotPromptFields } from 'src/types'

export const useGenerateAndPostTweet = () => {
  return useMutation(
    (promptName: EXBotPromptFields) => xService.generateAndPostTweet(promptName),
    {},
  )
}
